import axios from 'axios'

// 获取总数统计
export function getTotalCount() {
  return axios.get(process.env.VUE_APP_BASE_API + '/statistics/totalCount')
}

// 获取每月记事统计
export function getMonthNoteCount() {
  return axios.get(process.env.VUE_APP_BASE_API + '/statistics/monthNoteCount')
}

// 获取各类物品数量统计
export function getItemTypeCount() {
  return axios.get(process.env.VUE_APP_BASE_API + '/statistics/itemTypeCount')
}

// 获取用户总数统计（仅超级管理员）
export function getUserTotalCount() {
  return axios.get(process.env.VUE_APP_BASE_API + '/statistics/userTotalCount')
}

// 获取所有用户记事和物品数量统计（仅超级管理员）
export function getAllUserCount() {
  return axios.get(process.env.VUE_APP_BASE_API + '/statistics/allUserCount')
}

export default {
  getTotalCount,
  getMonthNoteCount,
  getItemTypeCount,
  getUserTotalCount,
  getAllUserCount
}